/* eslint-disable import/prefer-default-export */

const countries = {
  UK: 'UNITED KINGDOM',
  AU: 'AUSTRALIA',
  JP: 'JAPAN',
  IT: 'ITALY',
  FR: 'FRANCE',
  CN: 'CHINA',
  EU: 'EUROPEAN',
};

const measureUnits = {
  IN: 'inches',
  CM: 'centimeters',
};

/** @param {Object<string, number>} property */
const mapUnits = (property) => (
  Object.assign(
    {},
    ...Object.keys(property).map((key) => ({
      [measureUnits[key]]: property[key],
    })),
  ));

/** @param {Object} itemData */
const isItemDataEmpty = (itemData) => !itemData || (typeof itemData === 'object' && Object.keys(itemData).length < 1);

/** @param {sizeChartMapper} sizeChartInfo */
export const sizeChartMapper = (sizeChartInfo) => {
  const { sizeChart } = sizeChartInfo;
  const { sizeChartData } = sizeChart;

  const tabsEnabled = !sizeChart?.intimates && sizeChart?.tabs?.length > 1;
  const stepsEnabled = !!sizeChart?.intimates && sizeChartData?.length > 1;
  const chartDatakeys = sizeChartData?.length ? Object.keys(sizeChartData) : [];

  for (let k = 0; k < chartDatakeys.length; k += 1) {
    const sizeChartTableRenderData = [];
    const chartData = sizeChartData[chartDatakeys[k]];

    for (let i = 0; i < chartData.chartSizes.length; i += 1) {
      sizeChartTableRenderData.push(chartData.chartSizes[i]);
    }

    for (let i = 0; i < chartData.measureHeaders.length; i += 1) {
      chartData.measureHeaders[i].unitClasses = {};
      for (let j = 0; j < chartData.measureHeaders[i].units.length; j += 1) {
        /** @type {keyof { IN: string; CM: string; }} unit */
        const unit = chartData.measureHeaders[i].units[j];
        const val = measureUnits[unit] ? measureUnits[unit] : unit;
        chartData.measureHeaders[i].unitClasses[val] = unit;
      }
    }

    for (let i = 0; i < chartData.measureSizes.length; i += 1) {
      const measureSizeEntries = Object.entries(chartData.measureSizes[i].value);

      for (let j = 0; j < measureSizeEntries.length; j += 1) {
        const [key, measureSize] = measureSizeEntries[j];
        chartData.measureSizes[i].value[key].unitClasses = mapUnits(measureSize);
      }
    }

    for (let i = 0; i < chartData.localeSizes.length; i += 1) {
      sizeChartTableRenderData[i].localeSizes = chartData.localeSizes[i].value;
    }

    // Add country name for each country code
    for (let i = 0; i < chartData.columns.length; i += 1) {
      const countryName = countries[chartData.columns[i].name];
      chartData.columns[i].value = countryName || chartData.columns[i].name;
    }

    const hasLearnMore = !!(!isItemDataEmpty(chartData.learnMore) && chartData.learnMore.text);
    const hasImage = !!(!isItemDataEmpty(chartData.sizeChartImage) && chartData.sizeChartImage.image);

    chartData.sizeChartTableRenderData = sizeChartTableRenderData;
    chartData.rightColumnEnabled = (hasImage || hasLearnMore);
  }

  sizeChart.tabsEnabled = tabsEnabled;
  sizeChart.stepsEnabled = stepsEnabled;

  return sizeChart;
};
